<template>
    <div>
        <template v-if="$route.params.siteId && $route.params.userId && $route.params.siteName">
            <router-view></router-view>
        </template>
        <v-col v-else class="my-0 py-0 px-0 px-md-8 pb-15">
            <v-col class="text-start mt-5 pb-0">
                <v-alert text dense color="#8061c2" border="left" class="pl-5">
                    <h1 class="title mt-1">Links rotos</h1>
                    <p class="desc mt-0 mb-1">Aquí puedes ver los enlaces rotos de instagram sitios, su estado y detalles.</p>
                    <v-chip
                    class="mt-2 mr-2"
                    color="#8061c2"
                    label
                    outlined
                    >Total links rotos: &nbsp; <strong>{{ totals.broken }}</strong></v-chip>
                    <v-chip
                    class="mt-2 mr-2"
                    color="#1E88E5"
                    label
                    outlined
                    >Total links Pendientes: &nbsp;<strong>{{ totals.pendings }}</strong></v-chip>
                    <v-chip
                    class="mt-2 mr-2"
                    color="#388E3C"
                    label
                    outlined
                    >Total links funcionales: &nbsp; <strong>{{ totals.functional }}</strong></v-chip>
                </v-alert>
            </v-col>

            <!-- Search Bar y Filtros -->
            <v-row class="mx-3">
                <v-col cols="12" md="4" class="px-0">
                    <v-text-field
                        v-model="search"
                        @input="fetchBrokenLinks"
                        color="#8061c2"
                        label="Buscar"
                        append-icon="mdi-magnify"
                        single-line
                        hide-details
                        outlined
                        class="mb-2 mx-0 px-0"
                    ></v-text-field>
                </v-col>


                
                <v-col cols="12" md="2" class="pr-0 ">
                    <v-select
                        v-model="status"
                        :items="statusOptions"
                        @change="fetchBrokenLinks"
                        label="Ver"
                        outlined
                        hide-details
                    ></v-select>
                </v-col>
                
                <v-col cols="12" md="" class="px-md-2 px-0">
                    <v-select
                        v-model="filter"
                        :items="filterOptions"
                        label="Filtrar por"
                        outlined
                        hide-details
                    ></v-select>
                </v-col>

                <v-col cols="12" md="2" class="px-0 ">
                    <v-select
                        v-model="order"
                        :items="orderOptions"
                        label="Ordenar"
                        outlined
                        hide-details
                    ></v-select>
                </v-col>

            </v-row>

            <!-- Tabla de datos -->
            <v-data-table
                :headers="headers"
                :items="brokenLinks"
                :loading="loading"
                class="elevation-1 mx-3 px-2 py-4"
                :items-per-page="perPage"
                :server-items-length="totalBrokenLinks"
                :page.sync="page"
                :footer-props="{
                    itemsPerPageOptions: [50, 100, 200, 300, -1], 
                    showFirstLastPage: true
                }"
                @update:page="fetchBrokenLinks"
                @update:items-per-page="changePerPage"
            >
                <!-- Columnas y Templates -->
                <template v-slot:item.site.logo_path="{ item }">
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-avatar
                                size="35"
                                class="clickable-avatar"
                                @click="showLogo(item.site.logo_path)"
                                @mouseover="hoveredLogo = item.site.logo_path"
                                @mouseleave="hoveredLogo = null"
                                v-bind="attrs"
                                v-on="on"
                            >
                                <v-img :src="item.site.logo_path" v-if="item.site.logo_path"></v-img>
                                <v-img :src="require('../../../assets/illustrations/no-photo.jpg')" v-else></v-img>
                            </v-avatar>
                        </template>
                        <span>Ver Imagen</span>
                    </v-tooltip>
                </template>



                <template v-slot:item.instagram_username="{ item }">

                    <a :href="`https://www.instagram.com/${item.instagram_username}`" target="_blank">{{ item.instagram_username }}</a>

                </template>

                
                <template v-slot:item.account_exists="{ item }">
                    <v-chip :color="getStatusColor(item.account_exists)" dark small>
                        {{ item.account_exists === null ? 'Pendiente' : item.account_exists === 0 ? 'Inactivo' : 'Activo' }}
                    </v-chip>
                </template>


                <!-- Botones de acciones -->
                <template v-slot:item.actions="{ item }">
                    <!-- Nuevo botón para ir al Harmony -->
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn icon color="green" v-bind="attrs" v-on="on" @click="goToHarmony(item.site.slug)">
                                <v-icon>mdi-web</v-icon>
                            </v-btn>
                        </template>
                        <span>Ir al Harmony</span>
                    </v-tooltip>

                    <!-- Botón para impersonar usuario con tooltip -->
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn icon color="rgb(128 97 194)" v-bind="attrs" v-on="on" @click="impersonateUser(item.user_id)">
                                <v-icon>mdi-account-switch</v-icon>
                            </v-btn>
                        </template>
                        <span>Impersonar Usuario</span>
                    </v-tooltip>


                </template>

            </v-data-table>

            <!-- Modal para ampliar el logo -->
            <v-dialog v-model="dialog" max-width="14rem" class="rounded-lg">
                <v-img :src="selectedLogo" width="14rem"></v-img>
            </v-dialog>
        </v-col>
    </div>
</template>

<script>
import axios from '@/axios.js';
import impersonationMixin from '@/mixins/impersonationMixin';
import harmonyMixin from '@/mixins/harmonyMixin';
import statisticsMixin from '@/mixins/statisticsMixin';
import linksMixin from '@/mixins/linksMixin';

export default {
    name: "Harmonys",
    mixins: [impersonationMixin, harmonyMixin, statisticsMixin, linksMixin],
    data() {
        return {
            statistics: [],
            wppOrEmails: [],
            brokenLinks: [],
            search: '',  // Término de búsqueda
            loading: true,
            dialog: false,
            selectedLogo: null,
            page: 1,
            perPage: 50,
            totalBrokenLinks: 0,
            totalRegister: 0,
            totalsLinkPending: 0,
            totalsLinkBroken: 0,
            totalsLinkFunctional: 0,
            order: 'desc',
            filter: 'last_verified_at',
            status: 'all',
            headers: [
                { text: 'Logo', value: 'site.logo_path', align: 'start', sortable: false },
                { text: 'Harmony', value: 'site.name', align: 'start' },
                { text: 'Nick Instagram', value: 'instagram_username', sortable: true },
                { text: 'Estado', value: 'account_exists', sortable: true },
                { text: 'Intentos de verificacion', value: 'verification_attempts', sortable: true },
                { text: 'Ultima verificacion', value: 'last_verified_at', sortable: false },
                { text: 'Acciones', value: 'actions', sortable: false }
            ],
            statusOptions: [
                { text: 'Todos', value: 'all' },
                { text: 'Activos', value: 'functional' },
                { text: 'Inactivos', value: 'broken' },
                { text: 'Pendientes', value: 'pending' }
            ],
            orderOptions: [
                { text: 'Mayor', value: 'desc' },
                { text: 'Menor', value: 'asc' }
            ],
            filterOptions: [
                { text: 'Fecha Creación', value: 'created_at' },
                { text: 'Última Verificación', value: 'last_verified_at' },
                { text: 'Intentos de Verificación', value: 'verification_attempts' }
            ],
        };
    },

    watch: {
        order(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.fetchBrokenLinks();
            }
        },
        filter(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.fetchBrokenLinks();
            }
        }
    },
    computed: {
        totals(){
            const linkPending = Number(this.totalsLinkPending);
            const linkBroken = Number(this.totalsLinkBroken);
            const linksFunctional = Number(this.totalsLinkFunctional);

            const allValid = [linkPending, linkBroken, linksFunctional].every(v => !isNaN(v));

            if(allValid){
                return{
                    pendings: linkPending.toLocaleString('en-US'),
                    broken: linkBroken.toLocaleString('en-US'),
                    functional: linksFunctional.toLocaleString('en-US')
                }
            }else{
                return{
                    pendings: '0',
                    broken: '0',
                    functional: '0'
                }
            }
        }
    },
    created() {
        this.initializeSearch();
        this.fetchBrokenLinks();
        this.$i18n.locale = 'es';
    },
    methods: {
        initializeSearch() {
            const searchQuery = this.$route.query.search;
            if (searchQuery) {
                this.search = searchQuery;
            }
        },
        async fetchBrokenLinks() {
            this.loading = true;
            try {
                const response = await axios.get('/admin/get-broken-links', {
                    params: {
                        page: this.page,
                        per_page: this.perPage,
                        search: this.search,
                        sort_order: this.order,
                        sort_field: this.filter,
                        show: this.status
                    }
                });

                this.brokenLinks = response.data.data.data;
                this.totalBrokenLinks = response.data.data.total;
                this.totalsLinkPending = response.data.total_pending_links;
                this.totalsLinkBroken = response.data.total_broken_links;
                this.totalsLinkFunctional = response.data.total_functional_links;

            } catch (error) {
                console.error(error);
            } finally {
                this.loading = false;
            }
        },

        getStatusColor(statusId) {
            switch (statusId) {
                case 0: return 'red';
                case 1: return 'green';
                default: return 'orange';
            }
        },


        changePerPage(newPerPage) {
            this.perPage = newPerPage;
            this.page = 1;
            this.fetchBrokenLinks();
        },

        showLogo(logoPath) {
            this.selectedLogo = logoPath ? logoPath : require('../../../assets/illustrations/no-photo.jpg');
            this.dialog = true;
        },
    }
};
</script>

<style scoped>
.title {
    font-size: 22px !important;
    color: #8061c2;
}

.desc {
    color: #737373;
    font-size: 15px;
}

.clickable-avatar:hover {
    transform: scale(1.2);
    transition: transform 0.3s ease;
}
</style>
